import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import DataToothExam from "@/services/DataToothExam";
import store from "@/store";
import type { ToothExam, ToothExamValue } from "@/types/odontogram";

@Module({ store, dynamic: true, name: "storeToothExam" })
class StoreToothExam extends VuexModule {
  toothExamValues: ToothExamValue[] = [];
  currentEncounterId = "";
  toothExams: ToothExam[] = [];

  @Mutation SET_VALUES(values: ToothExamValue[]) {
    this.toothExamValues = values;
  }

  @Mutation SET_EXAMS({
    encounterId,
    exams
  }: {
    encounterId: string;
    exams: ToothExam[];
  }) {
    this.currentEncounterId = encounterId;
    this.toothExams = exams.slice();
  }

  @Action async loadValues() {
    const values = await DataToothExam.listValues();
    this.SET_VALUES(values);
  }

  @Action async loadForEncounter(encounterId: string) {
    const exams = await DataToothExam.getByEncounter(encounterId);
    this.SET_EXAMS({ encounterId, exams });
  }

  @Action async saveForEncounter({
    encounterId,
    exams
  }: {
    encounterId: string;
    exams: ToothExam[];
  }) {
    const saved = await DataToothExam.syncByEncounter(encounterId, exams);
    this.SET_EXAMS({ encounterId, exams: saved });
  }
}

export const storeToothExam = getModule(StoreToothExam);
